import { Box } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Dimensions, Keyboard } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
import { getBase64Image } from '../../util/util'
import { QrHeader } from './QrHeader'
import { QrInput } from './QrInput'
const { height } = Dimensions.get('window')
const EnterAmount = () => {
  const { getQrCode, merchantName, vpa } = useStores((root) => ({
    getQrCode: root.user.getQrCode,
    vpa: root.settings.metaData.vpa,
    merchantName: root?.settings?.metaData?.selectedMercName,
  }))
  const [amount, setAmount] = useState('')
  const [fetchDynamicQrCode, fetchQrCodeHandler] = useLazyApiData(getQrCode)

  useEffect(() => {
    if (fetchQrCodeHandler.state === 'fulfilled') {
      const txnId = fetchQrCodeHandler?.data?.id
      const imgUri = getBase64Image(fetchQrCodeHandler?.data?.qr)
      navigation.navigate(
        'generateQR' as never,
        {
          amount: amount,
          imgUri: imgUri,
          merchantName: merchantName,
          vpa: vpa,
          transactionId: txnId,
        } as never,
      )
    } else if (fetchQrCodeHandler.state === 'rejected') {
      // show toast
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, fetchQrCodeHandler.state])

  const navigation = useNavigation()
  const hideInputModal = () => {
    Keyboard?.dismiss()
    navigation.canGoBack() ? navigation.goBack() : navigation.navigate('dashboard' as never)
  }

  const handleGenerateQr = (amt: string) => {
    // console.log('generate dynamic QR', amt)
    fetchDynamicQrCode(amt)
    setAmount(amt)
  }

  return (
    <Box
      backgroundColor={'SECONDARY'}
      flex={1}
      alignItems="center"
      justifyContent={'space-between'}
      position={'relative'}>
      <QrHeader merchantName={merchantName} vpa={vpa} />
      <QrInput
        visible={true}
        state={fetchQrCodeHandler.state}
        hideModal={hideInputModal}
        handleGenerateQr={handleGenerateQr}
        amount={amount}
      />
    </Box>
  )
}

export default EnterAmount
